export const locale = {
  lang: 'es',
  data: {
    'COMPLEX_SELECTOR': {
      'CURRENT_COMPLEX': 'Complejo actual',
    },
  }
};
